import React from "react";

export default function BlogsPage() {
  return (
    <div className="pagemargin pixelfont">
      <h1>This is a Blogs Page</h1>
    </div>
  );
}
